import { client } from '@civilgrid/rest-client';

import getConfig from '~/config';
import { handleApiResponseError } from './common';

const config = getConfig();

client.setConfig({
  baseURL: config.apiServerBase,
  withCredentials: true,
  throwOnError: true,
});

client.instance.interceptors.request.use((requestConfig) => {
  const token = typeof window !== 'undefined' ? window.CG_TOKEN : undefined;
  if (token) {
    requestConfig.headers.set('Authorization', `Bearer ${token}`);
  }
  return requestConfig;
});

client.instance.interceptors.response.use((response) => response, handleApiResponseError);
